import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './features/auth/AuthContext';
import AppRoutes from './routes/AppRoutes';
import { StaticGenerationProvider } from './shared/contexts/StaticGenerationContext';

export function AppContent({ prerendered = false }) {
  return (
    <StaticGenerationProvider initial={prerendered}>
      <AuthProvider prerendered={prerendered}>
        <AppRoutes />
      </AuthProvider>
    </StaticGenerationProvider>
  );
}

export default function App({ prerendered = false }) {
  return <BrowserRouter><AppContent prerendered={prerendered} /></BrowserRouter>;
}
